"use strict";
// --------------------------------------------------
// HEIGHT HELPER
// Return a human-readable height value
// --------------------------------------------------
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.heightInches = exports.heightFeet = exports.height = void 0;
const isNaN_1 = __importDefault(require("lodash/isNaN"));
const isString_1 = __importDefault(require("lodash/isString"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function height(data) {
    // Convert the data to an integer
    if ((0, isString_1.default)(data))
        data = parseInt(data, 10);
    // Calculate the feet
    const feet = Math.floor(data / 12);
    // Calculate the inches
    const inches = data % 12;
    // Combine the measurements
    data = feet.toString() + "'" + inches.toString() + '"';
    if ((0, isNaN_1.default)(feet) || (0, isNaN_1.default)(inches)) {
        return 'Unknown';
    }
    return data;
}
exports.height = height;
function heightFeet(data) {
    let as_number;
    if (typeof data === 'string') {
        as_number = parseInt(data, 10);
    }
    else {
        as_number = data;
    }
    const result = Math.floor(as_number / 12);
    if ((0, isNaN_1.default)(result)) {
        return 'Unknown';
    }
    else {
        return result;
    }
}
exports.heightFeet = heightFeet;
function heightInches(data) {
    let as_number;
    if (typeof data === 'string') {
        as_number = parseInt(data, 10);
    }
    else {
        as_number = data;
    }
    const result = as_number % 12;
    if ((0, isNaN_1.default)(result)) {
        return 'Unknown';
    }
    else {
        return result;
    }
}
exports.heightInches = heightInches;
